"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CatalogStatusClient = void 0;
const tslib_1 = require("tslib");
const authenticated_client_1 = require("../../authenticated.client");
const settings_1 = require("../../../settings");
class CatalogStatusClient extends authenticated_client_1.AuthenticatedClient {
    constructor(settings = settings_1.DefaultClientSettings) {
        super(settings);
        this.settings = settings;
        this.executor.setFormatDateWithTimezone(true);
    }
    fetchProductStats(projectId, catalogId, request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return (yield this.httpPost(`/v1/projects/${projectId}/status/${catalogId}/stats`, request))
                .payload;
        });
    }
    fetchProductStatsNotMatched(projectId, catalogId, request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return ((yield this.httpPost(`/v1/projects/${projectId}/status/${catalogId}/stats/not-matched`, request)).payload || []);
        });
    }
    getImports(projectId, catalogId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { payload } = yield this.httpGet(`/v1/projects/${projectId}/status/${catalogId}/imports`);
            return payload;
        });
    }
    getImportErrors(projectId, catalogId, dateString) {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/projects/${projectId}/status/${catalogId}/imports/errors?date=${dateString}`);
            return ((_a = response.payload) === null || _a === void 0 ? void 0 : _a.errorLogs) || [];
        });
    }
    getDateRangeImportErrors(projectId, catalogId, from, to) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { payload } = yield this.httpGet(`/v1/projects/${projectId}/status/${catalogId}/imports/range-date-errors?${this.getQueryString({ from, to })}`);
            return payload;
        });
    }
    getProducts(projectId, catalogId, importId, request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v1/projects/${projectId}/status/${catalogId}/imports/${importId}/products`, request);
            return response.payload || [];
        });
    }
    exportStatus(projectId, catalogId, date) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/status/${catalogId}/status/export?date=${date}`;
            return this.executeRaw('get', url);
        });
    }
    exportProductNotMatch(projectId, catalogId, fromDate, toDate, eventType) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/status/${catalogId}/product-not-match/export?${this.getQueryString({
                fromDate,
                toDate,
                eventType,
            })}`;
            return this.executeRaw('get', url);
        });
    }
}
exports.CatalogStatusClient = CatalogStatusClient;
//# sourceMappingURL=catalog-status.client.js.map